<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="ack"></a><a id="page_ix">Acknowledgments</a></h2><a id="page_ix">
</a><p class="noindent"><a id="page_ix">One of the best parts of writing any book is the research. I love delving into the history, geography, and political climates of my settings. And one of the best parts of the “digging” is the contacts I make with the many individuals who are so willing to provide valuable information that contributes so greatly to the texture and flavor of each book. On that note, I’d like to give a very special thank-you to my Idaho connections, Larry Stone and Emma Scott, for ferreting out such incredible details on the Squaw Valley area of the Idaho panhandle and helping make the portion of the book set there so rich.</a><a id="page_x"></a></p><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?57e3e8ba